import { getCloudflareImageUrl } from "../utils/imageOptimization";
import TemplateCard from "./TemplateCard";
import { ColorPalleteSVG } from "./SVG.jsx";

const TemplateSection = ({ formData, setFormData }) => {
  const textures = [
    { id: "none", url: "", name: "Bez teksture" },
    {
      id: "texture1",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture1.jpg",
      name: "Tekstura 1",
    },
    {
      id: "texture2",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture2.jpg",
      name: "Tekstura 2",
    },
    {
      id: "texture3",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture3.jpg",
      name: "Tekstura 3",
    },
    {
      id: "texture4",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture4.jpg",
      name: "Tekstura 4",
    },
    {
      id: "texture5",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture5.jpg",
      name: "Tekstura 5",
    },
    {
      id: "texture6",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture6.jpg",
      name: "Tekstura 6",
    },
    {
      id: "texture7",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture7.jpg",
      name: "Tekstura 7",
    },
    {
      id: "texture8",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture8.jpg",
      name: "Tekstura 8",
    },
    {
      id: "texture9",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture9.jpg",
      name: "Tekstura 9",
    },
    {
      id: "texture10",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture10.jpg",
      name: "Tekstura 10",
    },
    {
      id: "texture11",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture11.jpg",
      name: "Tekstura 11",
    },
    {
      id: "texture12",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture12.jpg",
      name: "Tekstura 12",
    },
    {
      id: "texture13",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture13.jpg",
      name: "Tekstura 13",
    },
    {
      id: "texture14",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture14.jpg",
      name: "Tekstura 14",
    },
    {
      id: "texture15",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture15.jpg",
      name: "Tekstura 15",
    },
    {
      id: "texture16",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture16.jpg",
      name: "Tekstura 16",
    },
    {
      id: "texture17",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture17.jpg",
      name: "Tekstura 17",
    },
    {
      id: "texture18",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture18.jpg",
      name: "Tekstura 18",
    },
    {
      id: "texture19",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture19.jpg",
      name: "Tekstura 19",
    },
    {
      id: "texture20",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture20.jpg",
      name: "Tekstura 20",
    },
    {
      id: "texture21",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture21.jpg",
      name: "Tekstura 21",
    },
    {
      id: "texture22",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture22.jpg",
      name: "Tekstura 22",
    },
    {
      id: "texture23",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture23.jpg",
      name: "Tekstura 23",
    },
    {
      id: "texture24",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture24.jpg",
      name: "Tekstura 24",
    },
    {
      id: "texture25",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture25.jpg",
      name: "Tekstura 25",
    },
    {
      id: "texture26",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture26.jpg",
      name: "Tekstura 26",
    },
    {
      id: "texture27",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture27.jpg",
      name: "Tekstura 27",
    },
    {
      id: "texture28",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture28.jpg",
      name: "Tekstura 28",
    },
    {
      id: "texture29",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture29.jpg",
      name: "Tekstura 29",
    },
    {
      id: "texture30",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture30.jpg",
      name: "Tekstura 30",
    },
    {
      id: "texture31",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture31.jpg",
      name: "Tekstura 31",
    },
    {
      id: "texture32",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture32.jpg",
      name: "Tekstura 32",
    },
    {
      id: "texture33",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture33.jpg",
      name: "Tekstura 33",
    },
    {
      id: "texture34",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture34.jpg",
      name: "Tekstura 34",
    },
    {
      id: "texture35",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture35.jpg",
      name: "Tekstura 35",
    },
    {
      id: "texture36",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture36.jpg",
      name: "Tekstura 36",
    },
    {
      id: "texture37",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture37.jpg",
      name: "Tekstura 37",
    },
    {
      id: "texture38",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture38.jpg",
      name: "Tekstura 38",
    },
    {
      id: "texture39",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture39.jpg",
      name: "Tekstura 39",
    },
    {
      id: "texture40",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture40.jpg",
      name: "Tekstura 40",
    },
    {
      id: "texture41",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture41.jpg",
      name: "Tekstura 41",
    },
    {
      id: "texture42",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture42.jpg",
      name: "Tekstura 42",
    },
    {
      id: "texture43",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture43.jpg",
      name: "Tekstura 43",
    },
    {
      id: "texture44",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture44.jpg",
      name: "Tekstura 44",
    },
    {
      id: "texture45",
      url: "https://bucket.pozivnica.hr/ui-bucket/textures/texture45.jpg",
      name: "Tekstura 45",
    },
  ];

  const handleTextureChange = (textureUrl) => {
    setFormData({
      ...formData,
      texture: textureUrl,
    });
  };

  return (
    <div className="p-4 bg-gray-50 border border-dashed border-gray-200 rounded-xl     max-h-[70vh] overflow-y-scroll">
      <div className="space-y-6">
        <div>
          <label
            htmlFor="slug"
            className="block text-sm font-medium mb-2  "
          >
            Predložak
          </label>
          <div className="relative flex flex-row gap-x-4">
            <TemplateCard
              val={0}
              setFormData={setFormData}
              formData={formData}
            />
            {/* <TemplateCard val={1} setFormData={setFormData} formData={formData} /> */}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2">
            Pozadinska boja
          </label>
          <div className="flex items-center">
            <input
              type="color"
              value={formData.bgColor}
              onChange={(e) =>
                setFormData({ ...formData, bgColor: e.target.value })
              }
              className="sr-only"
              id="bgColorPicker"
            />
            <label
              htmlFor="bgColorPicker"
              className="p-1 cursor-pointer hover:bg-gray-100 rounded"
              title="Promijeni pozadinsku boju"
            >
              <ColorPalleteSVG className="w-5 h-5" />
            </label>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium mb-2  ">
            Pozadinska tekstura
          </label>
          <div className="grid grid-cols-3 gap-3 sm:grid-cols-5 overflow-y-scroll">
            {textures.map((texture) => (
              <div
                key={texture.id}
                onClick={() => handleTextureChange(texture.url)}
                className={`cursor-pointer p-1 border rounded-md ${
                  formData.texture === texture.url
                    ? "border-teal-500 ring-1 ring-teal-500"
                    : "border-gray-200 hover:border-gray-300"
                }`}
              >
                <div
                  className="h-16 w-full rounded-md flex items-center justify-center"
                  style={{
                    backgroundImage: texture.url
                      ? `url(${
                          texture.url
                            ? getCloudflareImageUrl(
                                texture.url,
                                "format=auto,width=150",
                              )
                            : ""
                        })`
                      : "none",
                    backgroundRepeat: "repeat",
                    backgroundColor: texture.url ? "transparent" : formData.bgColor,
                  }}
                >
                  {!texture.url && (
                    <span className="text-xs text-gray-500">Bez teksture</span>
                  )}
                </div>
                <p className="mt-1 text-xs text-center text-gray-700  ">
                  {texture.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateSection;
